import { render } from "./CategorySummaryCard.vue?vue&type=template&id=c0a8f57e&scoped=true"
import script from "./CategorySummaryCard.vue?vue&type=script&lang=js"
export * from "./CategorySummaryCard.vue?vue&type=script&lang=js"

import "./CategorySummaryCard.vue?vue&type=style&index=0&id=c0a8f57e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a8f57e"]])

export default __exports__